window['ThemeSection_ProductQuickBuy'] = ({
  product,
  variant,
  featuredMediaID,
}) => {
  return {
    productRoot: null,
    product: product,
    current_variant: variant,
    featured_media_id: featuredMediaID,
    current_media_id: featuredMediaID,
    loading: false,
    quantity: '1',
    options: [],
    optionHandles: [],
    addedToCart: false,
    subscriptionPriceMultiplier: 1,
    showPurchaseOptions: false,
    subscribeStep: '',
    hasSubscriptionOptions: false,
    get currentVariantId() {
      if (this.current_variant) {
        return this.current_variant.id;
      } else {
        return null;
      }
    },
    get currentVariantAvailable() {
      if (this.current_variant) {
        return this.current_variant.available;
      } else {
        return null;
      }
    },
    // SV- avoid crash when no variant match; apply subscription multiplier
    get current_price() {
      let base;
      if (this.current_variant) {
        base = this.current_variant.price;
      } else {
        base = this.product?.variants?.[0]?.price ?? 0;
      }
      const mult = this.subscriptionPriceMultiplier ?? 1;
      return Math.round(base * mult);
    },
    formatMoney(price) {
      return formatMoney(price, theme.moneyFormat);
    },
    getQuickBuyRoot() {
      return this.productRoot || this.$el.closest('.product-quick-buy');
    },
    getQuickBuyForm() {
      if (this.$refs.productForm) return this.$refs.productForm;
      const root = this.getQuickBuyRoot();
      if (!root) return null;
      return (
        root.querySelector('form.quick-buy-product-form') ||
        root.querySelector('form[data-product-form]')
      );
    },
    getSubWidgetData() {
      const root = this.getQuickBuyRoot();
      const el = root?.querySelector('.sub-widget--quick-buy');
      if (!el || !el._x_dataStack) return null;
      return el._x_dataStack[0];
    },
    init() {
      this.productRoot = this.$root;
      this.hasSubscriptionOptions = !!this.$root.querySelector(
        '.sub-widget--quick-buy'
      );
      this.$el.addEventListener('sv-subscription-pricing', (e) => {
        this.subscriptionPriceMultiplier = e.detail?.multiplier ?? 1;
      });
      if (this.$refs.productForm) {
        this.$refs.productForm.addEventListener(
          'submit',
          this.submitForm.bind(this)
        );
      }
      this.getOptions();
    },
    mainSelectorChange() {
      const matchedVariant = ShopifyProduct.getVariantFromId(
        this.product,
        parseInt(this.$refs.singleVariantSelector.value)
      );
      this.updateVariant(matchedVariant);
    },
    optionChange() {
      this.getOptions();
      const matchedVariant = ShopifyProduct.getVariantFromOptionArray(
        this.product,
        this.options
      );
      this.updateVariant(matchedVariant);
    },
    updateVariant(variant) {
      this.current_variant = variant;
      if (this.current_variant) {
        if (this.current_variant.featured_media) {
          this.current_media_id = this.current_variant.featured_media.id;
        }
      }
    },
    getOptions() {
      this.options = [];
      this.optionHandles = [];

      let selectors = this.$root.querySelectorAll(
        '[data-single-option-selector]'
      );

      selectors.forEach((selector) => {
        if (selector.nodeName === 'SELECT') {
          const value = selector.value;
          this.options.push(value);
          this.optionHandles.push(
            selector.options[selector.selectedIndex].dataset.handle
          );
        } else {
          if (selector.checked) {
            const value = selector.value;
            this.options.push(value);
            this.optionHandles.push(selector.dataset.handle);
          }
        }
      });
    },
    handleAddToCartClick() {
      if (this.loading || !this.currentVariantAvailable) return;
      if (!this.hasSubscriptionOptions) {
        this.addToCart();
        return;
      }
      this.subscribeStep = '';
      this.showPurchaseOptions = true;
    },
    cancelPurchaseOptions() {
      this.showPurchaseOptions = false;
      this.subscribeStep = '';
      const widget = this.getSubWidgetData();
      if (widget) {
        widget.selected_type = 'one-time';
        widget.UpdateBtnPrice();
      }
    },
    chooseOneTime() {
      const widget = this.getSubWidgetData();
      if (widget) {
        widget.selected_type = 'one-time';
        widget.UpdateBtnPrice();
      }
      this.showPurchaseOptions = false;
      this.subscribeStep = '';
      this.addToCart();
    },
    chooseSubscribe() {
      const widget = this.getSubWidgetData();
      if (!widget) return;
      widget.selected_type = 'subscribe';
      if (
        !widget.selling_plan &&
        widget.selling_plans[0]?.selling_plans?.[0]
      ) {
        widget.selling_plan = widget.selling_plans[0].selling_plans[0].id;
      }
      widget.UpdateBtnPrice();
      if (widget.selling_plans.length > 1) {
        this.subscribeStep = 'frequency';
        return;
      }
      this.showPurchaseOptions = false;
      this.subscribeStep = '';
      this.addToCart();
    },
    confirmSubscribe() {
      const widget = this.getSubWidgetData();
      if (!widget || !widget.selling_plan) return;
      this.showPurchaseOptions = false;
      this.subscribeStep = '';
      this.addToCart();
    },
    applySellingPlan(formData) {
      const widget = this.getSubWidgetData();
      if (!widget || widget.selected_type === 'one-time') {
        formData.delete('selling_plan');
        return;
      }
      const root = this.getQuickBuyRoot();
      const planId =
        widget.selling_plan ||
        root?.querySelector('select[name="selling_plan"]')?.value;
      if (planId) {
        formData.set('selling_plan', planId);
      }
    },
    submitForm(evt) {
      evt.preventDefault();
      this.handleAddToCartClick();
    },
    addToCart() {
      const form = this.getQuickBuyForm();
      if (!form) return;

      this.loading = true;

      liveRegion(window.theme.strings.loading);
      const formData = new FormData(form);
      this.applySellingPlan(formData);
      let modalCart = theme.settings.cart_type === 'modal';
      const config = fetchConfigDefaults('javascript');

      if (modalCart) {
        formData.append('sections', 'cart-items,cart-footer,cart-item-count');
        formData.append('sections_url', window.location.pathname);
      }

      config.body = formData;
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      fetch(`${theme.routes.cart_add_url}`, config)
        .then((res) => res.json())
        .then((data) => {
          this.loading = false;
          this.addedToCart = true;

          if (modalCart) {
            document.body.dispatchEvent(
              new CustomEvent('shapes:modalcart:afteradditem', {
                bubbles: true,
                detail: { response: data },
              })
            );
          }

          if (!document.querySelector('[data-show-on-add="true"]')) {
            if (this.$refs.added)
              this.$nextTick(() => this.$refs.added.focus());
          }
        })
        .catch((error) => {
          error.json().then((a) => {
            this.loading = false;
            alert(a.description);
          });
        });
    },
  };
};
